import { createFileRoute } from "@tanstack/react-router";

import MarketingLayout from "@/components/marketing/MarketingLayout";

/**
 * A sibling of `_app`, not a child: the blog is public, and `_app` mounts the
 * authenticated provider tree whose `RouteGuard` would redirect anonymous
 * readers to the login page.
 */
export const Route = createFileRoute("/blog")({
  component: MarketingLayout,
});
